import { SweetPath } from 'sweet-path';
import { ADMIN_IMPERSONATE_SECRET_PATH_SEGMENT } from 'env';

// Private module
export const TEST_PAGE_PATH = new SweetPath('/private/test');
export const ADMIN_IMPERSONATE_USER_PAGE_PATH = new SweetPath<'userId'>(
  `/private/impersonate/${ADMIN_IMPERSONATE_SECRET_PATH_SEGMENT}/:userId`
);
export const REDIRECT_PAGE_PATH = new SweetPath('/redirect');
export const EXTERNAL_REDIRECT_PAGE_PATH = new SweetPath('/external-redirect');
export const NOT_FOUND_PAGE_PATH = new SweetPath('/404');
export const DEVICE_QR_PAGE_PATH = new SweetPath<'qrId'>('/qr/:qrId');

// Profile module
export const WELCOME_PAGE_PATH = new SweetPath('/welcome');
export const LOGIN_PAGE_PATH = new SweetPath('/login');
export const RESET_PASSWORD_PAGE_PATH = new SweetPath('/reset-password');
export const SET_NEW_PASSWORD_PAGE_PATH = new SweetPath('/set-new-password');
export const EXPIRED_RESET_LINK_PAGE_PATH = new SweetPath('/expired-link');
export const PASSWORD_CHANGE_REQUIRED_PAGE_PATH = new SweetPath('/password-change-required');
export const MY_PROFILE_PAGE_PATH = new SweetPath('/profile');
export const MY_CERTIFICATES_PAGE_PATH = new SweetPath('/my-certificates');
export const MY_COMPANY_SETTINGS_PAGE_PATH = new SweetPath('/my-company-settings');
export const NOTIFICATION_SETTINGS_PAGE_PATH = new SweetPath('/notifications-settings/:userId');
export const LOGOUT_PAGE_PATH = new SweetPath('/logout');
export const DEVICE_TYPES_PAGE_PATH = new SweetPath('/device-types');
export const DEVICE_SUBTYPES_PAGE_PATH = new SweetPath('/device-types/:deviceTypeId/subtypes');
export const ADD_DEVICE_SUBTYPE_PAGE_PATH = new SweetPath('/device-types/:deviceTypeId/subtypes/add');
export const EDIT_DEVICE_SUBTYPE_PAGE_PATH = new SweetPath<'deviceTypeId' | 'deviceSubtypeId'>(
  '/device-types/:deviceTypeId/subtypes/edit/:deviceSubtypeId'
);
export const REVISION_TEMPLATES_PAGE_PATH = new SweetPath('/revision-templates');
export const ADD_REVISION_TEMPLATE_PAGE_PATH = new SweetPath('/revision-templates/add');
export const EDIT_REVISION_TEMPLATE_PAGE_PATH = new SweetPath<'revisionTemplateId'>(
  '/revision-templates/edit/:revisionTemplateId'
);
export const COPY_REVISION_TEMPLATE_PAGE_PATH = new SweetPath<'revisionTemplateId'>(
  '/revision-templates/copy/:revisionTemplateId'
);

// Admin module
export const USERS_PAGE_PATH = new SweetPath('/users');
export const ADD_USER_PAGE_PATH = new SweetPath('/users/add');
export const EDIT_USER_PAGE_PATH = new SweetPath<'userId'>('/users/edit/:userId');
export const ORGANIZATIONS_PAGE_PATH = new SweetPath('/organizations');
export const ADD_ORGANIZATION_PAGE_PATH = new SweetPath('/organizations/add');
export const EDIT_ORGANIZATION_PAGE_PATH = new SweetPath<'organizationId'>('/organizations/edit/:organizationId');
export const DEPARTMENTS_PAGE_PATH = new SweetPath('/departments');
export const ADD_DEPARTMENT_PAGE_PATH = new SweetPath('/departments/add');
export const EDIT_DEPARTMENT_PAGE_PATH = new SweetPath<'departmentId'>('/departments/edit/:departmentId');
export const HIERARCHIES_PAGE_PATH = new SweetPath('/hierarchies');
export const ADD_HIERARCHY_PAGE_PATH = new SweetPath('/hierarchies/add');
export const EDIT_HIERARCHY_PAGE_PATH = new SweetPath<'hierarchyId'>('/hierarchies/edit/:hierarchyId');
export const REMOTE_SOURCES_PAGE_PATH = new SweetPath('/remote-sources');
export const ADD_REMOTE_SOURCE_PAGE_PATH = new SweetPath('/remote-sources/add');
export const EDIT_REMOTE_SOURCE_PAGE_PATH = new SweetPath<'remoteSourceId'>('/remote-sources/edit/:remoteSourceId');
export const COPY_REMOTE_SOURCE_PAGE_PATH = new SweetPath<'remoteSourceId'>('/remote-sources/copy/:remoteSourceId');
export const CONFIG_REMOTE_SOURCE_PAGE_PATH = new SweetPath<'remoteSourceId'>('/remote-sources/config/:remoteSourceId');
export const DASHBOARD_PAGE_PATH = new SweetPath('/');
export const EXPORT_PAGE_PATH = new SweetPath('/export');

// HR module
export const HR_PEOPLE_PAGE_PATH = new SweetPath('/hr/people');
export const HR_CREATE_PERSON_PAGE_PATH = new SweetPath('/hr/people/create');
export const HR_COPY_PERSON_PAGE_PATH = new SweetPath<'personId'>('/hr/people/copy/:personId');
export const HR_EDIT_PERSON_PAGE_PATH = new SweetPath<'personId'>('/hr/people/:personId/edit');
export const HR_CREATE_PERSON_TERM_PAGE_PATH = new SweetPath<'personId'>('/hr/people/:personId/terms/create');
export const HR_CREATE_PERSON_FILE_PAGE_PATH = new SweetPath<'personId'>('/hr/people/:personId/files/create');
export const HR_EDIT_PERSON_FILE_PAGE_PATH = new SweetPath<'personId' | 'personFileId'>(
  '/hr/people/:personId/files/:personFileId/edit'
);
export const HR_TERMS_PAGE_PATH = new SweetPath('/hr/terms');
export const HR_BULK_CREATE_TERMS_PAGE_PATH = new SweetPath('/hr/terms/create');
export const HR_TERM_PAGE_PATH = new SweetPath<'termId'>('/hr/terms/:termId');
export const HR_TERM_TYPES_PAGE_PATH = new SweetPath('/hr/settings/term-types');
export const HR_CREATE_TERM_TYPE_PAGE_PATH = new SweetPath('/hr/settings/term-types/create');
export const HR_EDIT_TERM_TYPE_PAGE_PATH = new SweetPath<'termTypeId'>('/hr/settings/term-types/:termTypeId/edit');
export const HR_FILE_CATEGORIES_PAGE_PATH = new SweetPath('/hr/settings/file-categories');
export const HR_CREATE_FILE_CATEGORY_PAGE_PATH = new SweetPath('/hr/settings/file-categories/create');
export const HR_EDIT_FILE_CATEGORY_PAGE_PATH = new SweetPath<'categoryId'>(
  '/hr/settings/file-categories/:categoryId/edit'
);

// Pre-defined data module
export const USERS_PREDEFINED_DATA_PAGE_PATH = new SweetPath('/predefined-data/user');
export const ADD_USERS_PREDEFINED_DATA_PAGE_PATH = new SweetPath('/predefined-data/user/add');
export const EDIT_USERS_PREDEFINED_DATA_PAGE_PATH = new SweetPath<'predefinedDataId'>(
  '/predefined-data/user/edit/:predefinedDataId'
);
export const GLOBAL_PREDEFINED_DATA_PAGE_PATH = new SweetPath('/predefined-data/global');
export const ADD_GLOBAL_PREDEFINED_DATA_PAGE_PATH = new SweetPath('/predefined-data/global/add');
export const EDIT_GLOBAL_PREDEFINED_DATA_PAGE_PATH = new SweetPath<'predefinedDataId'>(
  '/predefined-data/global/edit/:predefinedDataId'
);
export const MEASURING_DEVICES_PAGE_PATH = new SweetPath('/measuring-devices');
export const ADD_MEASURING_DEVICE_PAGE_PATH = new SweetPath('/measuring-devices/add');
export const EDIT_MEASURING_DEVICE_PAGE_PATH = new SweetPath<'measuringDeviceId'>(
  '/measuring-devices/edit/:measuringDeviceId'
);

// Revisions module
export const REVISIONS_PAGE_PATH = new SweetPath('/revisions');
export const ADD_REVISION_PAGE_PATH = new SweetPath('/revisions/add');
export const REVISION_PAGE_PATH = new SweetPath<'revisionId'>('/revisions/revision/:revisionId');
export const COPY_REVISION_PAGE_PATH = new SweetPath<'revisionId'>('/revisions/copy/:revisionId');
export const EDIT_REVISION_PAGE_PATH = new SweetPath<'revisionId'>('/revisions/edit/:revisionId');
export const FILL_OUT_REVISION_PAGE_PATH = new SweetPath<'revisionId'>('/revisions/fill-out/:revisionId');
export const REVISION_PLAN_ASSIGNMENTS_PAGE_PATH = new SweetPath<'revisionId'>(
  '/revisions/plan-assignments/:revisionId'
);
export const SELECT_REVISION_TEMPLATE_AND_VISUAL_PAGE_PATH = new SweetPath<'revisionId'>(
  '/revisions/select-template/:revisionId'
);

// Forms module
export const FORMS_PAGE_PATH = new SweetPath('/forms');
export const ADD_FORM_PAGE_PATH = new SweetPath('/forms/add');
export const FORM_PAGE_PATH = new SweetPath<'revisionId'>('/forms/form/:revisionId');
export const COPY_FORM_PAGE_PATH = new SweetPath<'revisionId'>('/forms/copy/:revisionId');
export const EDIT_FORM_PAGE_PATH = new SweetPath<'revisionId'>('/forms/edit/:revisionId');
export const FILL_OUT_FORM_PAGE_PATH = new SweetPath<'revisionId'>('/forms/fill-out/:revisionId');
export const SELECT_FORM_TEMPLATE_AND_VISUAL_PAGE_PATH = new SweetPath<'revisionId'>(
  '/forms/select-template/:revisionId'
);

// Price offers module
export const PRICE_OFFERS_PAGE_PATH = new SweetPath('/price-offers');
export const ADD_PRICE_OFFER_PAGE_PATH = new SweetPath('/price-offers/add');
export const PRICE_OFFER_PAGE_PATH = new SweetPath<'priceOfferId'>('/price-offers/:priceOfferId');
export const PROVIDE_PRICE_OFFER_PAGE_PATH = new SweetPath<'priceOfferId'>('/price-offers/:priceOfferId/provide');

// Signatures
export const SIGNATURES_PAGE_PATH = new SweetPath('/signatures');
export const SIGNATURE_PAGE_PATH = new SweetPath<'kepMessageUuid'>('/signatures/signature/:kepMessageUuid');

export const DEVICES_PAGE_PATH = new SweetPath('/devices');
export const FAULTS_PAGE_PATH = new SweetPath('/faults');
export const ADD_DEVICE_PAGE_PATH = new SweetPath('/devices/add');
export const EDIT_DEVICE_PAGE_PATH = new SweetPath<'deviceId'>('/devices/edit/:deviceId');
export const COPY_DEVICE_PAGE_PATH = new SweetPath<'deviceId'>('/devices/copy/:deviceId');
export const DEVICE_FAULTS_PAGE_PATH = new SweetPath('/devices/device/:deviceId/faults');
export const DEVICE_REVISION_PLANS_PAGE_PATH = new SweetPath('/revision-plans');
export const TEMPLATE_EDITOR_PAGE_PATH = new SweetPath<'revisionTemplateId'>(
  '/revision-templates/template-editor/:revisionTemplateId'
);
export const EVIDENCE_FIELD_SECTIONS_PAGE_PATH = new SweetPath('/evidence-field-sections');
export const ADD_EVIDENCE_FIELD_SECTION_PAGE_PATH = new SweetPath('/evidence-field-sections/add');
export const EDIT_EVIDENCE_FIELD_SECTION_PAGE_PATH = new SweetPath<'sectionId'>(
  '/evidence-field-sections/edit/:sectionId'
);
export const EVIDENCE_FIELDS_PAGE_PATH = new SweetPath('/evidence-fields');
export const ADD_EVIDENCE_FIELD_PAGE_PATH = new SweetPath('/evidence-fields/add');
export const EDIT_EVIDENCE_FIELD_PAGE_PATH = new SweetPath<'evidenceFieldId'>('/evidence-fields/edit/:evidenceFieldId');
